import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const DB7_Last = ({ pdfExportComponent, data, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`เอกสารยืนยันการตรวจสอบสมุดบัญชีธนาคารเพื่อรับเงินเดือนหรือค่าจ้างของพนักงาน - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="formId"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "80px",
                  fontSize: "20px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font-bold">HRM-057</b>
              </div>
              <div
                id="header"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "130px",
                  right: "47px",
                  fontSize: "20px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b className="docs-font-bold">เอกสารแนบท้ายสัญญาจ้าง</b>
              </div>

              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "225px",
                  right: "74px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                  // backgroundColor: "red"
                }}
              >
                วันที่..................เดือน.................................พ.ศ...................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "254px",
                  right: "75px",
                  fontSize: "20px",
                  // fontFamily: "angsaLight",
                  width: "650px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp; ข้าพเจ้า(นาย/นาง/นางสาว)
                .................................................................................................อายุ..............ปี
                ตำแหน่ง
                ................................................................................<br />
                หน่วยงาน/True Shop สาขา
                .....................................................................................................................
                <br />
                ได้รับทราบถึงข้อปฏิบัติเรื่องที่ต้องตรวจสอบเอกลักษณ์ลูกค้า
                เทียบกับเอกสารตัวจริงและสำเนาทุกครั้ง
                ในงานธุรกรรมที่เกี่ยวข้องและข้าพเจ้ารับทราบข้อกำหนดดังนี้
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;1.
                ข้าพเจ้าจะไม่ได้รับค่าตอบแทนจากการให้บริการใดๆ
                หากเอกสารของลูกค้าที่ใช้ประกอบในการทำธุรกรรมไม่ครบถ้วนสมบูรณ์
                และ
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;2.
                กรณีมีปัญหาซึ่งเกิดความจงใจหรือประมาทเลินเล่อที่ข้าพเจ้าไม่ได้ตรวจสอบเอกลักษณ์ลูกค้าเทียบกับเอกสารดังกล่าว
                และหากมีการตรวจสอบพบว่ามีการทุจริตเกี่ยวกับเอกสารประกอบการทำธุรกรรม
                ข้าพเจ้าจะถูกดำเนินการเรียกค่าตอบแทนที่ได้รับไปก่อนหน้าคืน
                <br />
                <br />
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.............................................................(พนักงาน)
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(
                ............................................................ )
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "298px",
                  fontSize: "20px",
                  width: "62px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "159px",
                  fontSize: "20px",
                  width: "112px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224px",
                  right: "75px",
                  fontSize: "20px",
                  width: "64px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_year}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "280px",
                  right: "160px",
                  fontSize: "20px",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "280px",
                  right: "-47.5px",
                  fontSize: "20px",
                  width: "310px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.personal_info_age}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "305px",
                  right: "385px",
                  fontSize: "20px",
                  width: "300px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.detail_position}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "329px",
                  right: data?.detail_department?.length >= 49 ? "181.6px" : "245px",
                  fontSize: "20px",
                  width: "350px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data?.detail_department?.split("_")[1] ||
                  data?.detail_department?.split("_")[0]}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "680px",
                  right: "250px",
                  fontSize: "20px",
                  width: "202px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

DB7_Last.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default DB7_Last;
